angular.module('leanlaw').controller('CustomReportSidebarCtrl', ['$scope', '$rootScope', 'userService', function ($scope, $rootScope, userService) {
  $scope.filter = {
    accountFilter: null
  };
  $scope.accountFilterOptions = [];
  userService.me().then(me => {
    $scope.accountFilterOptions.push({
      id: 'primary',
      label: `${me.terms.Primary} ${me.terms.Lead}`
    });
    $scope.accountFilterOptions.push({
      id: 'originating',
      label: `Originating ${me.terms.Lead}`
    });
    $scope.filter.accountFilter = $scope.accountFilterOptions[0];
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  });
  $scope.$watch("filter", () => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);
}]);